module.exports = __webpack_public_path__ + "img/c-f_bg.0966d47d.png";